var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
var DEFAULT_STYLE = {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    border: '1px solid #E7EAF0',
    borderRadius: 10,
    minHeight: 0,
};
var BorderdContainer = forwardRef(function (_a, ref) {
    var children = _a.children, style = _a.style;
    var mergedStyle = style ? __assign(__assign({}, DEFAULT_STYLE), style) : DEFAULT_STYLE;
    return (React.createElement("div", { ref: ref, style: mergedStyle }, children));
});
export default BorderdContainer;
